import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TrafficNewsService } from '../../services/traffic-news/traffic-news.service';
import { TrafficNewsModel, TrafficNewsOption } from '../../models/traffic-news-model';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { SeoMetaService } from 'src/app/modules/aa-core/services/seo-meta-service';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { BaseRouterComponent } from 'src/app/modules/aa-core/components/base-router/base-router.component';
import { GoogleMapOptionsEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { AppError } from 'src/app/core/models/constants';
import { AppService } from 'src/app/modules/aa-core/services/app-service/app.service';

@Component({
    selector: 'app-traffic-news',
    templateUrl: './traffic-news.component.html',
    styleUrls: ['./traffic-news.component.scss'],
    standalone: false
})
export class TrafficNewsComponent extends BaseRouterComponent implements OnInit, OnDestroy {
  public trafficNewsModel: TrafficNewsModel;
  public locationModel: AALocationModel;

  @ViewChild('hybridGoogleMap', { static: true }) googleMapElement: any;

  constructor(private trafficNewsService: TrafficNewsService,
    public appService: AppService,
    public seoService: SeoMetaService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public eventServices: EventsService,
    public appUtilityService: AppUtilityService) {
    super(activatedRoute, router, appUtilityService, seoService);

    this.appService.routerType = this.routerType = AARouterURL.TRAFFIC_NEWS;
    this.trafficNewsModel = this.trafficNewsService.trafficNewsModel;
    this.locationModel = this.trafficNewsModel.locationModel;
  }

  ngOnInit() {
    this.applySiteTag();
    this.loadParams();
    this.applySEO();
  }

  public initMap(params: any): void {
    this.trafficNewsService.initMap(params);
  }

  public onWindowResize(): void {
    this.trafficNewsService.loadDefaltTrafficAlert(500);
  }

  getSelectToPlace(event) {
    this.locationModel.setName(event.item.description);
    this.onFindLocation();
  }

  onFindLocation() {
    this.trafficNewsService.updateRouterURL();
    // this.trafficNewsService.loadMapData(GoogleMapType.TRAFFIC_NEWS, true);
  }

  trafficOptionsChanged(optionsMap: Array<TrafficNewsOption>) {
    if (optionsMap) {
      this.trafficNewsService.updateTrafficAlert(optionsMap);
    }
  }

  ngOnDestroy() {
    this.unSubscribeObservableEvents();
    this.trafficNewsService.destroy(GoogleMapType.TRAFFIC_NEWS);
    this.eventServices.dispatch(GoogleMapOptionsEvents.CLEAR_CLRSTER_DATA);

  }

 get isLocationFeature() {
    return this.locationModel.errorMessage === AppError.LOCATION_ACCESS_FEATURE_TURNON ? true : false;
 }

}
